<div *ngIf="label?.length > 0" class="dropdown-label" [class.-disabled]="disabled">
  {{ label }}
</div>
<div class="dropdown" [class.-active]="display">
  <div class="dropdown-value" [class.-active]="display" [class.-disabled]="disabled">
    {{ value }}
    <ng-content select="[dropdown-value]"></ng-content>
  </div>
  <app-svg-icon class="arrow" src="./assets/icons/dropdown-arrow"></app-svg-icon>
</div>

<div class="content" *ngIf="display">
  <ng-content select="app-ep-dropdown-option"></ng-content>
</div>
